import { REQUEST, RECEIVE, SELECT } from '../../types/bezirke'
import { getCurrentTs } from '../../utils/Utils'

const initialState = {
    list: [],
    selected: null,
    isFetching: false,
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case RECEIVE:
            return Object.assign({}, state, {
                list: action.data,
                timestamp: getCurrentTs(),
                isFetching: false
            })
        case REQUEST:
            return Object.assign({}, state, {
                isFetching: true
            })
        case SELECT:
            return Object.assign({}, state, {
                selected: action.name
            })
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/referenten/bezirke.js